/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIV1AuthEmailRequestCheckTokenCreate200Response
 */
export interface APIV1AuthEmailRequestCheckTokenCreate200Response {
    /**
     * 
     * @type {string}
     * @memberof APIV1AuthEmailRequestCheckTokenCreate200Response
     */
    detail?: string;
}

/**
 * Check if a given object implements the APIV1AuthEmailRequestCheckTokenCreate200Response interface.
 */
export function instanceOfAPIV1AuthEmailRequestCheckTokenCreate200Response(value: object): value is APIV1AuthEmailRequestCheckTokenCreate200Response {
    return true;
}

export function APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON(json: any): APIV1AuthEmailRequestCheckTokenCreate200Response {
    return APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSONTyped(json, false);
}

export function APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIV1AuthEmailRequestCheckTokenCreate200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'detail': json['detail'] == null ? undefined : json['detail'],
    };
}

export function APIV1AuthEmailRequestCheckTokenCreate200ResponseToJSON(value?: APIV1AuthEmailRequestCheckTokenCreate200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'detail': value['detail'],
    };
}

